import Obj from './obj';
import Func from './func';

/**
 * 模块说明
 * -------
 * 工具集 (isomorphic-utils)
 * @description Do NOT write any non-isomorphic code
 * @author Kenneth Kong
 */
export class Utils {
    // 对象工具
    Obj = Obj;
    obj = (value: Record<string, any>) => new Obj(value);

    // 函数工具
    Func = Func;

    // 数组分组
    segment = (source: any[], size: number) => {
        const split_counts = Math.ceil(source.length / size);
        return new Array(split_counts).fill(0).map((_, index: number) => {
            return source.slice(index * size, (index + 1) * size);
        });
    };

    // 排序并拼接参数
    sortParams = (params: any) => {
        // keys 排序
        const paramsKeys = Object.keys(params).sort();
        // 初始化参数
        let paramsString = '';
        for (const paramKey of paramsKeys) {
            // 判断如果不是int 或者 string, 剔除掉
            const type = typeof params[paramKey];
            if (type !== 'number' && type !== 'string') {
                continue;
            }
            paramsString += paramKey + '=' + params[paramKey] + '&';
        }
        // 截取末尾 '&'
        paramsString = paramsString.substring(0, paramsString.length - 1);
        return paramsString;
    };
}

export default new Utils();
